import { UserProfile } from "@sunrun/sales-experience-shared";
import { LoadingOverlay } from "@sunrun/experience-ui-components";
import { useUserProfile } from "../../providers/UserProfile";
import { OneAppointmentIFrame } from "components/organisms/OneAppointmentIFrame";
import { useHybridToken } from "providers/Auth";

const OneAppointment = () => {
  const { userProfile: userProfileData } = useUserProfile();
  return <AppointmentProtector user={userProfileData} />;
};

const AppointmentProtector = ({ user }: { user: UserProfile }) => {
  const hybridToken = useHybridToken();
  if (!hybridToken) {
    return <></>;
  }

  if (!user.userId && !user.contactId) {
    return <LoadingOverlay message="Loading..." />;
  }
  return <OneAppointmentIFrame />;
};

export { OneAppointment };
